import React, { useEffect, useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { api } from "@/lib/api";

const digits = (s) => (s || "").replace(/[^\d+]/g, "");

export default function Contact() {
  const { t, lang } = useLanguage();
  const [info, setInfo] = useState({ phone: "", whatsapp: "", email: "", address_ar: "", address_en: "" });

  useEffect(() => {
    api.get("/contact-info").then(({ data }) => setInfo(data)).catch(() => {});
  }, []);

  const address = lang === "ar" ? info.address_ar : info.address_en;

  const items = [
    info.phone && {
      icon: Phone,
      label: lang === "ar" ? "اتصال هاتفي" : "Phone",
      value: info.phone,
      href: `tel:${digits(info.phone)}`,
    },
    info.whatsapp && {
      icon: MessageCircle,
      label: "WhatsApp",
      value: info.whatsapp,
      href: `https://wa.me/${digits(info.whatsapp).replace(/^\+/, "")}`,
    },
    info.email && {
      icon: Mail,
      label: lang === "ar" ? "البريد الإلكتروني" : "Email",
      value: info.email,
      href: `mailto:${info.email}`,
    },
    address && {
      icon: MapPin,
      label: lang === "ar" ? "العنوان" : "Address",
      value: address,
    },
  ].filter(Boolean);

  return (
    <div className="max-w-3xl mx-auto px-6 py-16 page-enter" data-testid="contact-page">
      <div className="text-xs uppercase tracking-widest text-[#D4AF37] mb-2">M16</div>
      <h1 className="font-display text-4xl mb-3">{t("contactUs")}</h1>
      <p className="text-[#9CA3AF] mb-10">
        {lang === "ar"
          ? "نحن هنا لمساعدتك. تواصل معنا في أي وقت وسنرد عليك بأقصى سرعة."
          : "We're here to help. Reach out anytime and we'll respond as fast as possible."}
      </p>
      <div className="grid sm:grid-cols-2 gap-4" data-testid="contact-items">
        {items.map((it, i) => (
          <a key={i} href={it.href || "#"} className="flex items-center gap-4 p-5 border border-[#27272A] rounded-xl hover-lift">
            <div className="w-11 h-11 rounded-lg bg-[#D4AF37]/10 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37]">
              <it.icon size={18} />
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-[#9CA3AF]">{it.label}</div>
              <div className="text-sm num-ltr">{it.value}</div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
